module.exports = __webpack_public_path__ + "2ca0f2a129f609ffaf36e94bc67b276a.gif";